import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import {
    CompensationPayPeriodData,
    CompSnapshotCardData,
    CSNetPayData,
    EmployeeData,
} from '../interfaces/incentives-data';

@Injectable({
    providedIn: 'root',
})
export class CompSnapshotService {
    private serverUrl = 'https://' + window.location.host; // TODO Get url and version number from appsettings.
    private version = '0.5';
    private componentName = 'incentives';
    private _url = (this.serverUrl + '/api/v{version}/compsnapshot')
        .replace('{version}', this.version)
        .replace('{componentName}', this.componentName);

    constructor(private http: HttpClient) {}

    getPayPeriodData(params): Observable<CompensationPayPeriodData[]> {
        return this.http.post<CompensationPayPeriodData[]>(this._url + '/periods/', params);
    }

    getEmployeeData(): Observable<EmployeeData> {
        return this.http.post<EmployeeData>(this._url + '/employee', {});
    }

    getCompSnapshotData(
        cardParams,
        byEmpId: boolean = false,
        empID: string = ''
    ): Observable<CompSnapshotCardData> {
        if (byEmpId) {
            cardParams.empID = empID;
            return this.http.post<CompSnapshotCardData>(this._url + '/byempid', cardParams);
        }
        return this.http.post<CompSnapshotCardData>(this._url + '/', cardParams);
    }
}
